import { Form, Input, Typography, Button, message, AutoComplete } from "antd";
import { useAuth } from "./auth";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import "./Login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogin = (values) => {
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/login`, {
        email: values.email,
        password: values.password,
      })
      .then((res) => {
        auth.login(res.data);
        message.success(`Bienvenido, ${res.data.nombre}!`);
      })
      .catch((err) => {
        message.error("Usuario o contraseña incorrectos");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEmailChange = (value) => {
    setEmail(value);
    if (value.includes("@")) {
      const [user, domain] = value.split("@");
      const emailVendors = [
        "hotmail.com",
        "gmail.com",
        "outlook.com",
        "live.com",
        "yahoo.com",
        "icloud.com",
        "prodigy.net.mx",
        "telmex.com",
        "alestra.net.mx",
        "infinitum.com.mx",
        "terra.com.mx",
        "megared.net.mx",
        "cablevision.net.mx",
        "iusacell.net.mx",
        "bestel.com.mx",
        "marcatel.com.mx",
        "avantel.com.mx",
        "axtelecom.com.mx",
        "intercable.net.mx",
        "totalplay.com.mx",
        "izzi.mx",
        "wizz.mx",
      ];
      const filteredVendors = emailVendors.filter((vendor) => vendor.startsWith(domain));
      const options = filteredVendors.map((vendor) => `${user}@${vendor}`);
      setAutoCompleteOptions(options);
    } else {
      setAutoCompleteOptions([]);
    }
  };

  const [form] = Form.useForm();

  return (
    <div className="login-container">
      <div className="login-background-decoration"></div>
      <div className="login-card">
        <div className="login-header">
          <Typography.Title level={2} className="login-title">
            PREDIVER
          </Typography.Title>
          <Typography.Text className="login-subtitle">Sistema de Gestión de Inspecciones Eléctricas</Typography.Text>
        </div>

        <Form form={form} layout="vertical" onFinish={handleLogin} className="login-form">
          <Form.Item
            label="Correo Electrónico"
            name="email"
            rules={[{ required: true, message: "Por favor ingrese su correo electrónico", type: "email" }]}
          >
            <AutoComplete
              options={autoCompleteOptions.map((option) => ({ value: option }))}
              onChange={handleEmailChange}
              onSelect={(value) => setEmail(value)}
              size="large"
              placeholder="tu@email.com"
            >
              <Input className="corporate-input" />
            </AutoComplete>
          </Form.Item>

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: true, message: "Por favor ingrese su contraseña", type: "string" }]}
          >
            <Input.Password size="large" placeholder="••••••••" className="corporate-input" />
          </Form.Item>

          <div className="login-button-container">
            <Button type="primary" htmlType="submit" loading={loading} size="large" className="primary-button">
              Ingresar
            </Button>
            <Button onClick={() => navigate("/")} size="large" className="secondary-button">
              Volver
            </Button>
          </div>
        </Form>

        <div className="login-footer">
          <Typography.Text type="secondary" className="footer-text">
            © 2026 PREDIVER. Todos los derechos reservados.
          </Typography.Text>
        </div>
      </div>
    </div>
  );
}
